export const MOUSE_EVENT_BUTTON = {
  MAIN: 0,
  AUXILIARY: 1, // Middle button
  SECONDARY: 2,
  FOURTH: 3, // Browser Back button
  FIFTH: 4, // Browser Forward button
};

export const isMainOrMiddleClick = (event: MouseEvent) => {
  return (
    event.button === MOUSE_EVENT_BUTTON.MAIN ||
    event.button === MOUSE_EVENT_BUTTON.AUXILIARY
  );
};
